/**
 * PermGate — wraps any view that requires a specific permission.
 * If the user doesn't have the permission, renders a locked placeholder.
 */

import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { useAuth, type PermKey } from '../lib/auth'
import { Icon } from './Icon'

interface Props {
  perm: PermKey
  children: ReactNode
}

export function PermGate({ perm, children }: Props) {
  const { can } = useAuth()
  const { t } = useTranslation()
  if (can(perm)) return <>{children}</>

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
      <div className="w-16 h-16 rounded-2xl bg-ink-100 grid place-items-center mb-5">
        <Icon name="eye-off" className="w-7 h-7 text-ink-400" />
      </div>
      <h2 className="text-[18px] font-bold text-ink-900 mb-2">{t('gate.access_restricted')}</h2>
      <p className="text-sm text-ink-500 max-w-sm">
        {t('gate.no_permission')}
      </p>
    </div>
  )
}

/** @deprecated Use PermGate with perm="pulse" */
export function FinancialGate({ children }: { children: ReactNode }) {
  return <PermGate perm="pulse">{children}</PermGate>
}
